import React, { useState, useEffect } from "react";
import { fetchUserSubscriptionData } from "../../utilities/UserProfileUtilities";

function SubscriptionDetails() {
  const [subscriptions, setSubscriptions] = useState([]);

  useEffect(() => {
    const fetchSubscriptionData = async () => {
      const userData = await fetchUserSubscriptionData();
      if (userData) {
        setSubscriptions(userData.results);
      }
    };

    fetchSubscriptionData();
  }, []);

  return (
    <div className="container mt-5">
      {subscriptions.map((subscription, index) => (
        <div key={index} className="card shadow mb-3">
          <div className="card-header">
            <h3>{subscription.subscription_name}</h3>
          </div>
          <div className="card-body p-4">
            {Object.entries(subscription).map(([key, value]) => (
              <div key={key} className="mb-3 form-floating">
                <input
                  type="text"
                  className="form-control"
                  id={key + index}
                  value={value || "N/A"}
                  disabled={true}
                />
                <label htmlFor={key + index} className="form-label">
                  {key.split("_").join(" ").toUpperCase()}
                </label>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default SubscriptionDetails;
